import axios from 'axios'
import { host } from '../../../helper/config'

const PLUGINS_NAME = 'admin-classic-channel'

export const getAllChannel = async (token, region) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        region: region
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const updateChannel = async (token, payload) => {
    try {
        const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, payload, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
    } catch (err) {
        console.log('updateChannel error', err)
    }
    return false
}
